import React from 'react';

const PaymentRequestButtonAbout = () => {
  return (
    <div className="about-content">
      <h3>Documentation</h3>
      <ul>
        <li>
          <a href="https://stripe.com/docs/stripe-js/elements/payment-request-button" target="_blank" rel="noopener noreferrer">
            Accept a Payment
          </a>
        </li>
      </ul>
    </div>
  );
};

export default PaymentRequestButtonAbout;
